import { createContext } from "react";
const Context = createContext("Default Value");

export default Context;
